import { gql } from "@outschool/ui-apollo";
import { AttachmentFragment } from "@outschool/ui-components-classroom";
import { LeaderFragment } from "@outschool/ui-components-website";

export const pastTeachersQuery = gql`
  query PastTeachers($uid: ID!) {
    pastTeachers(userUid: $uid) {
      ...LeaderFragment
      video {
        ...AttachmentFragment
      }
    }
  }
  ${LeaderFragment}
  ${AttachmentFragment}
`;

export const pastTeachersParentProfileQuery = gql`
  query PastTeachersForParentProfile(
    $uid: ID!
    $profileLinkUid: String
    $publicView: Boolean
  ) {
    pastTeachersForParentProfile(
      userUid: $uid
      profileLinkUid: $profileLinkUid
      publicView: $publicView
    ) {
      ...LeaderFragment
      video {
        ...AttachmentFragment
      }
    }
  }
  ${LeaderFragment}
  ${AttachmentFragment}
`;
